module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "record-pop",
    attrs: {
      "title": "提示",
      "width": "800px",
      "visible": _vm.popState
    },
    on: {
      "update:visible": function($event) {
        _vm.popState = $event
      }
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v("历史版本")])]), _vm._v(" "), _c('div', {
    staticClass: "dia-content"
  }, [_c('div', {
    staticClass: "nav-line"
  }, [_c('div', {
    class: ['nav-item', {
      'act': _vm.navAct == 1
    }],
    on: {
      "click": function($event) {
        _vm.navChange(1)
      }
    }
  }, [_vm._v("楼宇")]), _vm._v(" "), _c('div', {
    class: ['nav-item', {
      'act': _vm.navAct == 2
    }],
    on: {
      "click": function($event) {
        _vm.navChange(2)
      }
    }
  }, [_vm._v("空间")])]), _vm._v(" "), _c('div', {
    staticClass: "c-block"
  }, [_c('recordBuilding', {
    attrs: {
      "distdata": _vm.resdata.industrialSpaceSnapshot,
      "hidden": _vm.navAct !== 1
    }
  }), _vm._v(" "), _c('recordFloor', {
    attrs: {
      "distdata": _vm.resdata.industrialSpaceFloorSnapshotList,
      "hidden": _vm.navAct !== 2
    }
  })], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-b8df3a08"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingInfos/components/recordPop.vue
// module id = 1552
// module chunks = 1